// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_p2g","cls2":"ResearchInterestsCard-cls2_dGM ResearchInterestsCard-cls1_p2g"};